import type { AuthorizedParcel } from '@dpdgroupuk/fmx-ui/types';

import { DepotActions } from '../../../../store/orm/Depot';

export const fetchParcelDepot = ({ parcel }: { parcel: AuthorizedParcel }) =>
  DepotActions.fetchDepotByCode(parcel.deliveryDepot.depotCode);
